module.exports = __webpack_public_path__ + "static/media/pickup_marker_icon_eta.5ad553bd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/flavours/cota/images/pickup_marker_icon_eta.svg
// module id = 610
// module chunks = 0